module.exports = __webpack_public_path__ + "static/media/ranger_circle.20e52f58.svg";